(() => {
  'use strict';
  if (window.AUVENNEV3RequestFixes) return;
  window.AUVENNEV3RequestFixes = true;

  const sv = (document.documentElement.lang || '').toLowerCase().startsWith('sv');
  const rootPath = () => ((window.Shopify?.routes?.root || '/').replace(/\/$/, '') + '/');
  const setText = (el, value) => {
    if (!el || !value) return;
    if ((el.textContent || '').trim() !== value) el.textContent = value;
  };
  const bestsellerHandles = new Set([
    'legame-knooparmband',
    'insieme-ring-set',
    'initiale-ring',
    'fortuna-clover-necklace'
  ]);

  function replaceShippingThreshold(root) {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(node => {
      if (node.parentElement && /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/.test(node.parentElement.tagName)) return;
      let next = node.nodeValue || '';
      next = next.replace(/€25/g, '€45').replace(/275 kr/g, '495 kr');
      if (!sv) {
        next = next.replace('Bekijk de productpagina', 'Gemiddeld 2–5 werkdagen');
        next = next.replace('De levertijd verschilt per sieraad. Ontbreekt informatie? Vraag het ons vóór je aankoop.', 'Gemiddeld 2–5 werkdagen. Je ontvangt tracking zodra die beschikbaar is.');
      }
      if (next !== node.nodeValue) node.nodeValue = next;
    });
  }

  function patchHelpShipping() {
    const help = document.querySelector('[data-auv-help]');
    const shipping = help && help.querySelector('#help-shipping');
    if (!shipping) return;

    replaceShippingThreshold(shipping);
    const grid = shipping.querySelector('.auv-help__market-grid');
    if (!grid) return;

    const details = Array.from(grid.querySelectorAll(':scope > details'));
    const find = words => details.find(item => words.some(word => (item.querySelector('summary')?.textContent || '').toLowerCase().includes(word)));
    const nl = find(['nederland', 'nederländerna']);
    const se = find(['zweden', 'sverige']);
    const nlP = nl && nl.querySelector('div p');
    const seP = se && se.querySelector('div p');

    setText(nlP, sv ? '€4,95 under €45. Fri frakt från €45. I genomsnitt 2–5 arbetsdagar.' : '€4,95 onder €45. Gratis verzending vanaf €45. Gemiddeld 2–5 werkdagen.');
    setText(seP, sv ? '66 kr under 495 kr. Fri frakt från 495 kr. I genomsnitt 2–5 arbetsdagar.' : '€6 onder €45. Gratis verzending vanaf €45. Gemiddeld 2–5 werkdagen.');

    let europe = Array.from(grid.querySelectorAll(':scope > details')).find(item => /europa/i.test(item.querySelector('summary')?.textContent || ''));
    if (!europe) {
      europe = document.createElement('details');
      europe.setAttribute('data-auv-europe-shipping', '');
      const summary = document.createElement('summary');
      const label = document.createElement('span');
      label.textContent = 'Europa';
      const icon = document.createElement('span');
      icon.setAttribute('aria-hidden', 'true');
      summary.append(label, icon);
      const body = document.createElement('div');
      const p = document.createElement('p');
      p.textContent = sv ? '6 € under 45 €. Fri frakt från 45 €. I genomsnitt 2–5 arbetsdagar.' : '€6 onder €45. Gratis verzending vanaf €45. Gemiddeld 2–5 werkdagen.';
      body.appendChild(p);
      europe.append(summary, body);
      grid.appendChild(europe);
    } else {
      setText(europe.querySelector('div p'), sv ? '6 € under 45 €. Fri frakt från 45 €. I genomsnitt 2–5 arbetsdagar.' : '€6 onder €45. Gratis verzending vanaf €45. Gemiddeld 2–5 werkdagen.');
    }
  }

  function patchCollection() {
    const nav = document.querySelector('.auv-collection-links');
    if (!nav) return;

    const path = location.pathname.replace(/\/$/, '');
    const allPath = rootPath() + 'collections/shop-all';
    if (!Array.from(nav.querySelectorAll('a')).some(a => new URL(a.href, location.origin).pathname.replace(/\/$/, '') === allPath.replace(/\/$/, ''))) {
      const all = document.createElement('a');
      all.href = allPath;
      all.textContent = sv ? 'Alla smycken' : 'Alle sieraden';
      nav.prepend(all);
    }

    nav.querySelectorAll('a').forEach(a => {
      const current = new URL(a.href, location.origin).pathname.replace(/\/$/, '') === path;
      if (current && a.getAttribute('aria-current') !== 'page') a.setAttribute('aria-current', 'page');
      if (!current && a.hasAttribute('aria-current')) a.removeAttribute('aria-current');
    });

    const handle = path.split('/').pop();
    const copyNl = {
      'shop-all': 'Alle AUVENNE-sieraden bij elkaar. Begin bij de nieuwe edit of ontdek rustig de rest van de collectie.',
      'nieuwe-sieraden': 'De nieuwste AUVENNE-sieraden, als eerste verzameld in de nieuwe edit.',
      'rings': 'Verstelbare en sculpturale ringen die je look met één detail afmaken.',
      'earrings': 'Hoops, parels en sculpturale oorbellen voor iedere dag en avond.',
      'bracelets': 'Cuffs, fijne lijnen en schakels om los te dragen of te combineren.',
      'necklaces': 'Kralen, hangers en fijne lijnen die mooi rond de hals vallen.',
      'letterringen': 'Persoonlijke ringen met initialen, gemaakt om jouw betekenis dichtbij te dragen.',
      'sets': 'Bijpassende vormen die al voor je zijn samengesteld en makkelijk samen te dragen zijn.'
    };
    const copySv = {
      'shop-all': 'Alla AUVENNE-smycken samlade på ett ställe. Börja med den nya kollektionen eller upptäck resten i lugn och ro.',
      'nieuwe-sieraden': 'De senaste AUVENNE-smyckena, samlade först i den nya kollektionen.',
      'rings': 'Justerbara och skulpturala ringar som fulländar din look med en detalj.',
      'earrings': 'Hoops, pärlor och skulpturala örhängen för både vardag och kväll.',
      'bracelets': 'Cuffs, fina linjer och länkar att bära ensamma eller tillsammans.',
      'necklaces': 'Pärlor, hängen och fina linjer som faller vackert runt halsen.',
      'letterringen': 'Personliga ringar med initialer som håller din betydelse nära.',
      'sets': 'Matchande former som redan är kombinerade och enkla att bära tillsammans.'
    };
    const intro = document.querySelector('.cro-collection__heading > p, .cro-collection__heading > div');
    const wanted = (sv ? copySv : copyNl)[handle];
    setText(intro, wanted);
  }

  function patchBestsellers() {
    document.querySelectorAll('.v3c[data-product-handle], .cro-card[data-product-handle]').forEach(card => {
      const handle = card.getAttribute('data-product-handle') || '';
      if (!bestsellerHandles.has(handle)) return;
      const visual = card.querySelector('.v3c__visual, .cro-card__image');
      if (!visual) return;
      const existing = visual.querySelector('.cro-card__badge');
      if (existing && !/nieuw|nytt|nyhet/i.test((existing.textContent || '').trim()) && !existing.classList.contains('auv-bestseller-badge')) return;
      let badge = visual.querySelector('.auv-bestseller-badge');
      if (!badge) {
        badge = existing || document.createElement('span');
        badge.className = card.classList.contains('v3c') ? 'auv-card-badge auv-bestseller-badge' : 'cro-card__badge auv-bestseller-badge';
        if (!existing) visual.appendChild(badge);
      } else {
        badge.classList.add('auv-bestseller-badge');
      }
      setText(badge, sv ? 'UTVALT AV AUVENNE' : 'AUVENNE SELECTIE');
    });
  }

  function patchCartClaims() {
    document.querySelectorAll('.auv-ad-combo__saving').forEach(el => {
      const value = (el.textContent || '').trim();
      if (/15%.*(gratis verzending|fri frakt)/i.test(value)) {
        setText(el, sv ? '15 % rabatt · automatiskt' : '15% korting · automatisch');
      }
    });
    document.querySelectorAll('.lu-cart__shipping .auv-cart__notice-main, .auv-drawer__notice-main').forEach(el => {
      const value = (el.textContent || '').trim();
      if (/15%.*(gratis verzending|fri frakt)/i.test(value)) {
        setText(el, sv ? 'Lägg till ett deltagande smycke till för 15 % kombinationsrabatt.' : 'Voeg nog 1 deelnemend sieraad toe voor 15% combinatiekorting.');
      }
    });
  }

  function patchSwedishPdpShipping() {
    if (!sv) return;
    document.querySelectorAll('.auv-pdp-reassure, [data-auv-calm-shipping]').forEach(el => {
      const value = (el.textContent || '').trim();
      if (/€4,95.*fri frakt från 495 kr/i.test(value)) {
        setText(el, value.replace('€4,95', '66 kr'));
      }
    });
  }

  function run() {
    patchHelpShipping();
    patchCollection();
    patchBestsellers();
    patchCartClaims();
    patchSwedishPdpShipping();
  }

  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      run();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, {once: true});
  else run();
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(schedule).observe(document.documentElement, {childList: true, subtree: true});
})();
